export function newURL(url: string | URL, base?: string | URL) {
  try {
    if (base !== undefined) {
      if (!URL.canParse(url, base)) throw new Error('The url is Invalid URL')
      return new URL(url, base)
    }
    else {
      if (!URL.canParse(url)) throw new Error('The url is Invalid URL')
      return new URL(url)
    }
  }
  catch (error) {
    console.error(error)
    return null
  }
}
